import React, { Component } from 'react'
import { ThemeProvider } from 'emotion-theming'

import defaulttheme from '../../constants/themeConstants'

import StatsContainer from './StatsContainer/index'
import NewsCard from './NewsCard'
import NewsLogos from './NewsLogos'
import {
  NewsCardHolder,
  NewsPageHolder,
  NewsPageHeadingHolder,
  NewsPageResponsiveHolder
} from './styledComponents'

class IbcNews extends Component {
  render() {
    const {
      newsDataList,
      newsLogosList,
      readFullStoryText,
      watchVideoText,
      statsData
    } = this.props
    return (
      <ThemeProvider theme={defaulttheme.newspage}>
        <NewsPageHolder>
          <NewsPageHeadingHolder>
            <NewsPageResponsiveHolder />
          </NewsPageHeadingHolder>
          <StatsContainer statsData={statsData} />
          <NewsLogos newsLogosList={newsLogosList} />
          <NewsPageResponsiveHolder>
            <NewsCardHolder>
              {newsDataList.map(news => (
                <NewsCard
                  news={news}
                  readFullStoryText={readFullStoryText}
                  watchVideoText={watchVideoText}
                />
              ))}
            </NewsCardHolder>
          </NewsPageResponsiveHolder>
        </NewsPageHolder>
      </ThemeProvider>
    )
  }
}

export default IbcNews



// WEBPACK FOOTER //
// ./src/components/IbcNews/index.js